import { GridToolbarContainer } from "@mui/x-data-grid";
import ResetColumnVisibilityButton from "../../table/ResetColumnVisibilityButton";

export const Toolbar = () => (
  <GridToolbarContainer>
    <ResetColumnVisibilityButton />
  </GridToolbarContainer>
);
